export default data => {
  if (process.env.VUE_APP_VERSION === "3") {
    const { markRaw } = require("vue")
    return markRaw(data)
  }
  return data
}
